import React from 'react';
import { Box, IconButton, tooltipClasses, Tooltip, Dialog, Typography, Stack } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import { Button } from '../../../components/core/Button/Button';
import { toast } from '../../../util/toast';

interface Props {
  open: boolean;
  onClose: () => void;
  newApiKey: string;
}

const ApiKeyCreatedModal = ({ open, onClose, newApiKey }: Props) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(newApiKey).then(() => {
      toast.success('API Key has been copied to your clipboard');
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 4,
          minWidth: { xs: '90%', md: '733px' },
          p: 3,
        },
      }}
    >
      <Stack spacing={2}>
        <Typography variant="xl" fontWeight="semibold">
          Your new API Key was created
        </Typography>

        <Typography
          variant="medium"
          fontWeight="semibold"
          sx={{ fontSize: { xs: '14px', md: '16px' } }}
        >
          Please copy your new API key and store it someplace safe. You will not be able to access
          it again if it is lost, and it cannot be regained after this window is closed.
        </Typography>
      </Stack>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mt: 4,
          mb: 6,
          overflowWrap: 'anywhere',
        }}
      >
        <Typography variant="medium" sx={{ mr: 0.5 }}>
          {newApiKey}
        </Typography>
        <IconButton onClick={handleCopy} size="small">
          <Tooltip
            title="Copy API key"
            placement="top"
            componentsProps={{
              popper: {
                sx: {
                  [`& .${tooltipClasses.tooltip}`]: {
                    backgroundColor: 'white',
                    color: 'black',
                  },
                },
              },
            }}
          >
            <ContentCopyIcon sx={{ fontSize: '24px', color: 'link.main', margin: 0.5 }} />
          </Tooltip>
        </IconButton>
      </Box>

      <Stack
        spacing={2}
        sx={{
          '& button': { height: '48px' },
        }}
      >
        <Button text="Copy API key" onClick={handleCopy} theme="secondary" form="api-key-created" />
        <Button text="Close" onClick={onClose} theme="primary" form="api-key-created" />
      </Stack>
    </Dialog>
  );
};

export default ApiKeyCreatedModal;
